<template>
    <console-content max-width="1280">

        <v-row class="mt-4 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span>재고관리</span>
            </v-col>
            <v-spacer/>
        </v-row>
		<giftcard-stock v-if="ready" :giftcard="giftcard"/>
    </console-content>
</template>

<script>
import api from "@/api";
import UploadDialog from "@/components/console/shop/giftcards/upload-dialog.vue";
import GiftcardStock from "@/components/console/shop/giftcards/giftcard-stock.vue";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";

export default {
    components: {
		UploadDialog,
		GiftcardStock,
        ConsoleContent
    },
    data(){
        return {
			ready: false,

			giftcard: {
                _id: this.$route.params._giftcard,

                no: 0,
                name: null,
                code: null,
                type: "giftcard",

                options: [],
                pins: [],
            },
        }
    },
    computed: {

    },
    methods: {
		async init() {
			let { giftcard } = await api.console.shop.giftcards.get({ _id: this.$route.params._giftcard });
            
            this.giftcard = giftcard;
            this.ready = true;
		},
    },
	async mounted(){
		await this.init()
    },
}
</script>